import React from "react";
import { useNavigate } from "react-router-dom";

import Button from "../../../components/Button/Button";

import "./PremiumGate.scss";

interface IProps {
  /** Dog's call name for the copy */
  dogName: string;
  /** What's gated — "Ribbon Room" or "Stats" */
  feature: string;
  /** Feature-specific benefits shown as bullets */
  bullets: string[];
}

/**
 * Shown in place of a premium-only tab (Ribbon Room / Stats) when the dog's
 * owner doesn't have the Dog Profile feature on their account. The rest of
 * the profile (header, Information tab, edit/share) stays available.
 */
const PremiumGate: React.FC<IProps> = ({ dogName, feature, bullets }) => {
  const navigate = useNavigate();
  return (
  <div className="premiumGate">
    <div className="premiumGateCard">
      <div className="eyebrow">Eager Dog Premium</div>
      <h2>{feature} is a Premium feature</h2>
      <p>
        Unlock {feature.toLowerCase()} for {dogName} and every dog on your account.
      </p>
      <ul>
        {bullets.map((b) => (
          <li key={b}>{b}</li>
        ))}
      </ul>
      <div className="cta">
        <Button onClick={() => navigate("/premium")}>Learn about Premium</Button>
      </div>
    </div>
  </div>
  );
};

export default PremiumGate;
